(function () {
  if (!window.__excludePublishers) return;

  var vendorSet = null;
  var handleSet = null;
  var blockedMessageRendered = false;

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function initSets() {
    if (vendorSet) return;
    vendorSet = new Set((window.__excludedPublisherVendors || []).map(normalize));
    handleSet = new Set((window.__excludedPublisherHandles || []).map(normalize));
  }

  function isExcludedVendor(vendor) {
    initSets();
    var normalized = normalize(vendor);
    if (!normalized) return false;
    return vendorSet.has(normalized) || handleSet.has(normalized);
  }

  function isExcludedHandle(handle) {
    initSets();
    return handleSet.has(normalize(handle));
  }

  function getCollectionHandleFromPath() {
    var match = (window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
    return match ? match[1] : '';
  }

  function renderBlockedMessage() {
    if (blockedMessageRendered) return;
    blockedMessageRendered = true;

    var main = document.getElementById('MainContent');
    if (!main) return;

    main.innerHTML =
      '<div class="publisher-exclusion-blocked page-width" style="padding:5rem 1.5rem;text-align:center;">' +
      '<h1 class="h2">No books found</h1>' +
      '<p>No books were found matching your selection.</p>' +
      '<a href="/" class="button button--primary">Continue shopping</a>' +
      '</div>';
  }

  function guardExcludedPublisherPage() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    if (main.querySelector('.publisher-exclusion-blocked')) {
      blockedMessageRendered = true;
      return;
    }

    if (document.body && document.body.getAttribute('data-publisher-excluded') === 'true') {
      renderBlockedMessage();
      return;
    }

    if (window.__publisherPageExcluded) {
      renderBlockedMessage();
      return;
    }

    var collectionHandle = getCollectionHandleFromPath();
    if (collectionHandle && isExcludedHandle(collectionHandle)) {
      renderBlockedMessage();
    }
  }

  function removeExcludedNavLinks(root) {
    var scope = root || document;

    scope.querySelectorAll('a[href*="/collections/"], a[href*="/pages/"]').forEach(function (anchor) {
      var path = anchor.pathname || '';
      var collectionMatch = path.match(/\/collections\/([^/?#]+)/i);
      var pageMatch = path.match(/\/pages\/([^/?#]+)/i);
      var handle = collectionMatch ? collectionMatch[1] : pageMatch ? pageMatch[1] : '';

      if (handle && isExcludedHandle(handle)) {
        var listItem = anchor.closest('li');
        var column = anchor.closest('.mega-menu__col');
        if (listItem) {
          listItem.remove();
        } else if (column) {
          column.remove();
        } else {
          anchor.remove();
        }
        return;
      }

      var vendorText = anchor.textContent || '';
      if (vendorText && isExcludedVendor(vendorText)) {
        var vendorListItem = anchor.closest('li');
        var vendorColumn = anchor.closest('.mega-menu__col');
        if (vendorListItem) {
          vendorListItem.remove();
        } else if (vendorColumn) {
          vendorColumn.remove();
        } else {
          anchor.remove();
        }
      }
    });
  }

  function shouldSkipExcludedNode(node) {
    if (!node || !node.getAttribute) return true;
    if (node === document.body || node === document.documentElement) return true;
    if (node.id === 'MainContent') return true;
    if (node.closest('.publisher-exclusion-blocked')) return true;
    if (node.closest('#product-grid[data-exclusion-pagination="true"]')) return true;
    return false;
  }

  function removeExcludedNodes(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-vendor]').forEach(function (node) {
      if (shouldSkipExcludedNode(node)) return;
      if (isExcludedVendor(node.getAttribute('data-vendor'))) {
        var gridItem = node.closest('.grid__item, .slider__slide, .product-card-wrapper, .card-wrapper');
        if (gridItem) {
          gridItem.remove();
        } else if (node.closest('.product-grid, .collection, .predictive-search, .featured-collection, .complementary-slider')) {
          node.remove();
        }
      }
    });

    scope.querySelectorAll('[data-publisher-handle]').forEach(function (node) {
      if (shouldSkipExcludedNode(node)) return;
      if (isExcludedHandle(node.getAttribute('data-publisher-handle'))) {
        node.remove();
      }
    });

    scope.querySelectorAll('.predictive-search__list-item[data-vendor]').forEach(function (node) {
      if (shouldSkipExcludedNode(node)) return;
      if (isExcludedVendor(node.getAttribute('data-vendor'))) {
        node.remove();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    removeExcludedNodes(document);
    removeExcludedNavLinks(document);
    guardExcludedPublisherPage();
  });

  document.addEventListener('product-grid:updated', function () {
    removeExcludedNodes(document.getElementById('ProductGridContainer') || document);
    removeExcludedNavLinks(document);
  });
})();
